// extracted by mini-css-extract-plugin
export default {"Navigation":"Navigationl85PlMBp3Xpw","Navigation-rule":"Navigation-rule1ycnjgk7uq0B"};